import React from "react";
import { Toaster } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DISCORD_URL = "https://discord.gg/nEvwBUtqAV";

const SECTIONS = [
  {
    title: "1. Your account",
    body: "You must be 13+ to register. Keep your credentials safe. You're responsible for anything done under your account. Sharing accounts, selling them, or transferring them is not allowed.",
  },
  {
    title: "2. Tournament participation",
    body: "By joining a tournament you agree to the event's rules and the Code of Conduct. Admins may disqualify, remove, or ban any participant who violates them. Prize awards (when applicable) require valid contact info and are paid out at the host's discretion.",
  },
  {
    title: "3. Content you post",
    body: "You keep ownership of team names, logos, and messages you upload, but you grant Spicy Community a non-exclusive licence to display them on the platform while you remain registered. Don't upload anything you don't have the right to share.",
  },
  {
    title: "4. Prohibited behaviour",
    body: "No cheating, botting, DDoS, match-fixing, selling accounts, scraping the platform, or using Spicy Community to promote hate or violence. Violations can result in immediate termination and are reported to the relevant platforms.",
  },
  {
    title: "5. No warranty / liability limits",
    body: "The platform is provided as-is. We don't guarantee uninterrupted access, that bracket results are bug-free, or that prizes will always pay out on time. To the extent allowed by law, we're not liable for indirect damages.",
  },
  {
    title: "6. Changes",
    body: "We may update these terms. Significant changes will be announced in Discord and on the site. Continued use after an update means you accept the new terms.",
  },
  {
    title: "7. Contact",
    body: "Questions? Reach us in our Discord #support channel or via the in-app Support page.",
  },
];

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-zinc-200">
      <Toaster position="top-right" theme="dark" />
      <Navbar />
      <section className="max-w-4xl mx-auto px-6 pt-12 pb-20">
        <div className="text-[10px] uppercase tracking-[0.3em] text-red-400 font-mono mb-3">
          Spicy Community
        </div>
        <h1 className="font-display font-extrabold text-4xl md:text-5xl mb-3">
          Terms of <span className="text-red-500">Service</span>
        </h1>
        <p className="text-zinc-400 max-w-2xl">
          The ground rules for using Spicy Community. Short version: play fair, don't break
          anything, and have fun.
        </p>
        <div className="mt-10 space-y-5">
          {SECTIONS.map((s, i) => (
            <div key={i} className="glass-dark rounded-2xl p-6">
              <h2 className="font-display font-bold text-lg mb-1.5 text-white">{s.title}</h2>
              <p className="text-sm leading-relaxed text-zinc-400">{s.body}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-zinc-500 mt-10">Last updated: April 2026</p>
      </section>
      <Footer discordUrl={DISCORD_URL} />
    </div>
  );
}
